import TreeSelect from './TreeSelect';
export default TreeSelect;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-treeselect/src/index.js